import { render, staticRenderFns } from "./PatientNotification.vue?vue&type=template&id=8654d8ce&scoped=true&"
import script from "./PatientNotification.vue?vue&type=script&lang=js&"
export * from "./PatientNotification.vue?vue&type=script&lang=js&"
import style0 from "./PatientNotification.vue?vue&type=style&index=0&id=8654d8ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8654d8ce",
  null
  
)

export default component.exports